const words = {
  ábaco: true,
  abajo: true,
  abecé: true,
  abeja: true,
  abeto: true,
  abono: true,
  abril: true,
  abrir: true,
  abuso: true,
  acabe: true,
  acabo: true,
  ácaro: true,
  acaso: true,
  acato: true,
  acera: true,
  acero: true,
  ácido: true,
  acilo: true,
  acodo: true,
  acose: true,
  acoso: true,
  actor: true,
  acuse: true,
  adiós: true,
  adoba: true,
  adobe: true,
  adobo: true,
  adoro: true,
  adula: true,
  aéreo: true,
  afear: true,
  áfono: true,
  afore: true,
  aforo: true,
  ágape: true,
  ágata: true,
  agave: true,
  ágora: true,
  agote: true,
  agrio: true,
  aguar: true,
  agudo: true,
  aguja: true,
  aguzo: true,
  ahogo: true,
  ahora: true,
  airar: true,
  aireo: true,
  ajeno: true,
  ajete: true,
  álabe: true,
  álamo: true,
  alano: true,
  albar: true,
  albor: true,
  álbum: true,
  aldea: true,
  alear: true,
  aleja: true,
  alelí: true,
  alelo: true,
  alero: true,
  aleta: true,
  alfar: true,
  alfil: true,
  algún: true,
  aliar: true,
  alijo: true,
  aliño: true,
  aloja: true,
  altar: true,
  aluda: true,
  aludo: true,
  álveo: true,
  alzar: true,
  amado: true,
  amago: true,
  amaño: true,
  amaro: true,
  ámbar: true,
  ambos: true,
  ameba: true,
  ameno: true,
  amida: true,
  amiga: true,
  amigo: true,
  amina: true,
  amino: true,
  ancha: true,
  ancho: true,
  ancla: true,
  andar: true,
  andén: true,
  anejo: true,
  anexo: true,
  ángel: true,
  anglo: true,
  ánima: true,
  anime: true,
  anión: true,
  ánodo: true,
  ansia: true,
  antes: true,
  antro: true,
  anual: true,
  ánulo: true,
  añada: true,
  añejo: true,
  añojo: true,
  añoso: true,
  aojar: true,
  aorta: true,
  aovar: true,
  apaño: true,
  apear: true,
  apego: true,
  apena: true,
  apero: true,
  ápice: true,
  apodo: true,
  ápodo: true,
  apoyo: true,
  apure: true,
  apuro: true,
  aquel: true,
  aqueo: true,
  árabe: true,
  arada: true,
  arado: true,
  araña: true,
  araño: true,
  árbol: true,
  arcén: true,
  arcón: true,
  arder: true,
  ardid: true,
  ardor: true,
  arduo: true,
  arena: true,
  argón: true,
  argot: true,
  árido: true,
  aries: true,
  armar: true,
  arnés: true,
  aroma: true,
  aromo: true,
  arpía: true,
  arpón: true,
  arras: true,
  arreo: true,
  arroz: true,
  asado: true,
  ascua: true,
  asear: true,
  asilo: true,
  asomo: true,
  astro: true,
  astur: true,
  atado: true,
  atajo: true,
  ataúd: true,
  ático: true,
  atino: true,
  átomo: true,
  atona: true,
  átono: true,
  atoro: true,
  atrás: true,
  atril: true,
  atrio: true,
  atroz: true,
  audaz: true,
  audio: true,
  augur: true,
  aunar: true,
  aupar: true,
  áureo: true,
  autor: true,
  avaro: true,
  avena: true,
  aveza: true,
  aviar: true,
  ávido: true,
  avión: true,
  aviso: true,
  axial: true,
  axila: true,
  ayuda: true,
  ayuno: true,
  azada: true,
  azote: true,
  babia: true,
  babor: true,
  bache: true,
  bacín: true,
  badén: true,
  badil: true,
  bafle: true,
  bagre: true,
  bahía: true,
  baila: true,
  baile: true,
  bajar: true,
  bajel: true,
  bajío: true,
  bajón: true,
  balar: true,
  balda: true,
  balde: true,
  balín: true,
  balón: true,
  balsa: true,
  bamba: true,
  bambú: true,
  banal: true,
  banca: true,
  banco: true,
  banda: true,
  bando: true,
  banjo: true,
  bañar: true,
  barba: true,
  barca: true,
  barco: true,
  bardo: true,
  baria: true,
  bario: true,
  barón: true,
  barra: true,
  barro: true,
  basal: true,
  basar: true,
  basta: true,
  baste: true,
  basto: true,
  bateo: true,
  batín: true,
  batir: true,
  bazar: true,
  beata: true,
  beato: true,
  beber: true,
  becar: true,
  bedel: true,
  beige: true,
  belén: true,
  belga: true,
  belio: true,
  bello: true,
  bemol: true,
  beque: true,
  besar: true,
  betún: true,
  bicho: true,
  bidón: true,
  biela: true,
  bilis: true,
  bingo: true,
  bioma: true,
  birra: true,
  bisel: true,
  bizco: true,
  blues: true,
  blusa: true,
  bocha: true,
  boina: true,
  bolín: true,
  bollo: true,
  bolsa: true,
  bolso: true,
  bomba: true,
  bombo: true,
  bonus: true,
  borda: true,
  borde: true,
  bordo: true,
  borla: true,
  borne: true,
  borro: true,
  bosta: true,
  botar: true,
  botín: true,
  botón: true,
  boxeo: true,
  bozal: true,
  braco: true,
  braga: true,
  brama: true,
  brasa: true,
  brava: true,
  bravo: true,
  braza: true,
  brazo: true,
  brega: true,
  brete: true,
  breva: true,
  breve: true,
  brezo: true,
  brial: true,
  bríos: true,
  brisa: true,
  broca: true,
  broma: true,
  bromo: true,
  brota: true,
  brote: true,
  bruja: true,
  brujo: true,
  bruma: true,
  bruta: true,
  bruto: true,
  bubón: true,
  bucal: true,
  buceo: true,
  buche: true,
  bucle: true,
  budín: true,
  buena: true,
  bueno: true,
  bufar: true,
  bufón: true,
  bujía: true,
  bulbo: true,
  bulla: true,
  bulto: true,
  buque: true,
  buqué: true,
  burda: true,
  burdo: true,
  burgo: true,
  burla: true,
  burra: true,
  burro: true,
  busca: true,
  busco: true,
  busto: true,
  buzón: true,
  buzos: true,
  cabal: true,
  caber: true,
  cable: true,
  cabra: true,
  cacao: true,
  cacho: true,
  cafre: true,
  caída: true,
  caído: true,
  cajón: true,
  calar: true,
  calca: true,
  calés: true,
  cáliz: true,
  calle: true,
  callo: true,
  calma: true,
  calmo: true,
  calor: true,
  calva: true,
  calvo: true,
  calza: true,
  calzo: true,
  campo: true,
  canal: true,
  canje: true,
  canoa: true,
  canso: true,
  canta: true,
  cante: true,
  canto: true,
  cañal: true,
  cañón: true,
  caoba: true,
  capar: true,
  capaz: true,
  capón: true,
  caqui: true,
  cardo: true,
  careo: true,
  carga: true,
  cargo: true,
  cariz: true,
  carné: true,
  carne: true,
  carpa: true,
  carpo: true,
  carro: true,
  carta: true,
  casar: true,
  casco: true,
  casón: true,
  caspa: true,
  casta: true,
  casto: true,
  catar: true,
  catre: true,
  cauce: true,
  causa: true,
  cavar: true,
  cazar: true,
  cebar: true,
  cebra: true,
  ceceo: true,
  ceder: true,
  cedro: true,
  cegar: true,
  celda: true,
  celta: true,
  cenar: true,
  cenit: true,
  censo: true,
  ceñir: true,
  cerca: true,
  cerco: true,
  cerda: true,
  cerdo: true,
  cerro: true,
  cesar: true,
  césar: true,
  cesio: true,
  cesta: true,
  cesto: true,
  cetro: true,
  ceutí: true,
  chafa: true,
  chalé: true,
  chapa: true,
  chata: true,
  chato: true,
  checo: true,
  chepa: true,
  chica: true,
  chico: true,
  chile: true,
  china: true,
  chino: true,
  chita: true,
  chivo: true,
  chopo: true,
  chota: true,
  choza: true,
  chulo: true,
  chute: true,
  chuzo: true,
  ciclo: true,
  cidra: true,
  cidro: true,
  ciego: true,
  cielo: true,
  cieno: true,
  cifra: true,
  cinco: true,
  cinta: true,
  circe: true,
  circo: true,
  cisma: true,
  cisne: true,
  citar: true,
  civil: true,
  clara: true,
  claro: true,
  clase: true,
  clava: true,
  clave: true,
  clavo: true,
  clero: true,
  clima: true,
  cloro: true,
  cobra: true,
  cobre: true,
  cobro: true,
  cocer: true,
  coche: true,
  codal: true,
  códex: true,
  cofre: true,
  coger: true,
  coima: true,
  coito: true,
  cojín: true,
  colar: true,
  colín: true,
  colmo: true,
  colon: true,
  color: true,
  comba: true,
  comer: true,
  cómic: true,
  común: true,
  conde: true,
  conga: true,
  conta: true,
  copar: true,
  copia: true,
  copla: true,
  copón: true,
  copto: true,
  coque: true,
  coral: true,
  corán: true,
  corea: true,
  corra: true,
  corro: true,
  corsé: true,
  corso: true,
  corta: true,
  corte: true,
  corto: true,
  corva: true,
  corvo: true,
  coser: true,
  costa: true,
  coste: true,
  costo: true,
  coxal: true,
  coxis: true,
  crack: true,
  craso: true,
  crear: true,
  credo: true,
  creer: true,
  crema: true,
  creta: true,
  criar: true,
  criba: true,
  cribo: true,
  croar: true,
  cromo: true,
  crono: true,
  cruce: true,
  crudo: true,
  cruel: true,
  cruza: true,
  cubil: true,
  cuero: true,
  cueva: true,
  culpa: true,
  culto: true,
  cuota: true,
  cupón: true,
  curar: true,
  curdo: true,
  curia: true,
  curio: true,
  curro: true,
  curry: true,
  cursi: true,
  curso: true,
  curva: true,
  curvo: true,
  cutis: true,
  cutre: true,
  dador: true,
  dalia: true,
  dance: true,
  danés: true,
  danza: true,
  dañar: true,
  dardo: true,
  datar: true,
  dátil: true,
  deber: true,
  débil: true,
  debut: true,
  decir: true,
  dedal: true,
  dejar: true,
  delta: true,
  demás: true,
  denso: true,
  dente: true,
  derbi: true,
  desde: true,
  deseo: true,
  deuda: true,
  deudo: true,
  diana: true,
  dicha: true,
  dicho: true,
  dieta: true,
  digno: true,
  dinar: true,
  diodo: true,
  dique: true,
  disco: true,
  diván: true,
  doble: true,
  doblo: true,
  dócil: true,
  docto: true,
  dogma: true,
  dólar: true,
  doler: true,
  dolor: true,
  domar: true,
  donar: true,
  donde: true,
  dónde: true,
  dopar: true,
  dorar: true,
  dorio: true,
  dosel: true,
  dosis: true,
  dotar: true,
  draga: true,
  drama: true,
  droga: true,
  ducal: true,
  ducha: true,
  ducho: true,
  dudar: true,
  duela: true,
  duelo: true,
  dueña: true,
  dueño: true,
  dueto: true,
  dulce: true,
  dupla: true,
  duque: true,
  durar: true,
  ébano: true,
  ebrio: true,
  echar: true,
  edema: true,
  ejido: true,
  élite: true,
  ellos: true,
  enano: true,
  encía: true,
  enema: true,
  enero: true,
  enojo: true,
  entre: true,
  entro: true,
  envés: true,
  envío: true,
  épica: true,
  épico: true,
  época: true,
  equis: true,
  erbio: true,
  erial: true,
  erizo: true,
  errar: true,
  error: true,
  espía: true,
  esquí: true,
  estar: true,
  estío: true,
  estos: true,
  etano: true,
  etapa: true,
  ética: true,
  ético: true,
  etilo: true,
  éxito: true,
  éxodo: true,
  extra: true,
  fácil: true,
  faena: true,
  fagot: true,
  fajín: true,
  fajón: true,
  falaz: true,
  falda: true,
  falla: true,
  fallo: true,
  falsa: true,
  falso: true,
  falta: true,
  falte: true,
  falto: true,
  fango: true,
  fardo: true,
  fario: true,
  farol: true,
  farra: true,
  farsa: true,
  fatal: true,
  fatuo: true,
  fauna: true,
  fauno: true,
  favor: true,
  fecal: true,
  fecha: true,
  fecho: true,
  feliz: true,
  felón: true,
  felpa: true,
  fémur: true,
  fénix: true,
  fenol: true,
  feria: true,
  feroz: true,
  ferry: true,
  fetal: true,
  feudo: true,
  fiado: true,
  fibra: true,
  ficha: true,
  ficus: true,
  fideo: true,
  fiera: true,
  fiero: true,
  fijar: true,
  filia: true,
  filme: true,
  filón: true,
  final: true,
  finar: true,
  finca: true,
  finés: true,
  finta: true,
  firma: true,
  firme: true,
  fisco: true,
  flaco: true,
  flato: true,
  fleco: true,
  flema: true,
  flexo: true,
  flojo: true,
  flora: true,
  flota: true,
  flote: true,
  fluir: true,
  flujo: true,
  flúor: true,
  focal: true,
  fogón: true,
  folio: true,
  fondo: true,
  foral: true,
  forja: true,
  forma: true,
  forro: true,
  forte: true,
  fósil: true,
  fotón: true,
  frase: true,
  freír: true,
  freno: true,
  fresa: true,
  freso: true,
  friso: true,
  frito: true,
  fruta: true,
  fruto: true,
  fuego: true,
  fuera: true,
  fuero: true,
  fugaz: true,
  fular: true,
  fumar: true,
  funda: true,
  fundo: true,
  furia: true,
  furor: true,
  fusil: true,
  fusta: true,
  fuste: true,
  futón: true,
  gabán: true,
  gacha: true,
  gacho: true,
  gafar: true,
  gaita: true,
  galán: true,
  galés: true,
  galga: true,
  galgo: true,
  galio: true,
  gallo: true,
  galón: true,
  gamba: true,
  gamma: true,
  ganar: true,
  ganga: true,
  ganso: true,
  gañán: true,
  garbo: true,
  garra: true,
  garza: true,
  garzo: true,
  gasto: true,
  gateo: true,
  gemir: true,
  genio: true,
  gente: true,
  geoda: true,
  gesta: true,
  gesto: true,
  girar: true,
  globo: true,
  glosa: true,
  glose: true,
  gnomo: true,
  gofre: true,
  goles: true,
  golfa: true,
  golfo: true,
  golpe: true,
  gorda: true,
  gordo: true,
  gorra: true,
  gorro: true,
  goteo: true,
  gozar: true,
  gozne: true,
  grada: true,
  grado: true,
  grafo: true,
  grajo: true,
  gramo: true,
  grana: true,
  grano: true,
  grapa: true,
  grasa: true,
  graso: true,
  grata: true,
  grato: true,
  grava: true,
  grave: true,
  greba: true,
  greca: true,
  greco: true,
  greda: true,
  greña: true,
  grial: true,
  grifo: true,
  grima: true,
  gripe: true,
  gripo: true,
  grisú: true,
  grita: true,
  grito: true,
  grumo: true,
  grupo: true,
  gruta: true,
  guano: true,
  guapo: true,
  gueto: true,
  guiar: true,
  güino: true,
  guiño: true,
  guisa: true,
  guiso: true,
  gulag: true,
  gusto: true,
  haber: true,
  hábil: true,
  habla: true,
  hacer: true,
  hacha: true,
  hache: true,
  hacia: true,
  hampa: true,
  harén: true,
  harpa: true,
  harto: true,
  hasta: true,
  hebra: true,
  hecha: true,
  hecho: true,
  heder: true,
  hedor: true,
  helar: true,
  helio: true,
  henar: true,
  henil: true,
  herir: true,
  héroe: true,
  hiato: true,
  hidra: true,
  hielo: true,
  hiena: true,
  hiera: true,
  hilar: true,
  himen: true,
  himno: true,
  hinco: true,
  hindi: true,
  hindú: true,
  hipar: true,
  hogar: true,
  honda: true,
  hondo: true,
  hongo: true,
  honor: true,
  honra: true,
  horca: true,
  horda: true,
  horma: true,
  horno: true,
  hosco: true,
  hotel: true,
  hucha: true,
  hueca: true,
  hueco: true,
  hueso: true,
  hueva: true,
  huevo: true,
  huida: true,
  huido: true,
  huilo: true,
  huira: true,
  hulla: true,
  humor: true,
  humus: true,
  hurón: true,
  hurto: true,
  húsar: true,
  ibero: true,
  icono: true,
  ictus: true,
  ideal: true,
  idear: true,
  ídolo: true,
  ígneo: true,
  igual: true,
  ileso: true,
  iluso: true,
  impar: true,
  impía: true,
  impío: true,
  inane: true,
  india: true,
  indio: true,
  ingle: true,
  iraní: true,
  islam: true,
  istmo: true,
  ítalo: true,
  itrio: true,
  izado: true,
  jabón: true,
  jadeo: true,
  jalar: true,
  jalea: true,
  jaleo: true,
  jamás: true,
  jamón: true,
  jaque: true,
  jarra: true,
  jarro: true,
  jaula: true,
  jején: true,
  jeque: true,
  jerbo: true,
  jerez: true,
  jerga: true,
  jirón: true,
  jonio: true,
  joven: true,
  jubón: true,
  judía: true,
  judío: true,
  juego: true,
  jugar: true,
  julio: true,
  junco: true,
  junio: true,
  junta: true,
  junto: true,
  jurar: true,
  justa: true,
  justo: true,
  kappa: true,
  karma: true,
  kayak: true,
  kebab: true,
  koala: true,
  koiné: true,
  kurdo: true,
  labia: true,
  labio: true,
  labor: true,
  labra: true,
  lacar: true,
  lacio: true,
  lacón: true,
  lacra: true,
  ladeo: true,
  ladra: true,
  laico: true,
  lamer: true,
  lamia: true,
  lanar: true,
  lance: true,
  landa: true,
  lanza: true,
  lápiz: true,
  lapón: true,
  lapso: true,
  larga: true,
  largo: true,
  larva: true,
  láser: true,
  látex: true,
  latín: true,
  latir: true,
  latón: true,
  lauro: true,
  lavar: true,
  laxar: true,
  lazar: true,
  leche: true,
  lecho: true,
  legal: true,
  legar: true,
  legua: true,
  leída: true,
  leído: true,
  lejía: true,
  lejos: true,
  lémur: true,
  lente: true,
  lento: true,
  lepra: true,
  lerda: true,
  lerdo: true,
  letal: true,
  letón: true,
  letra: true,
  liana: true,
  libio: true,
  libra: true,
  libre: true,
  libro: true,
  liceo: true,
  licor: true,
  licra: true,
  líder: true,
  lidia: true,
  lidio: true,
  ligar: true,
  ligur: true,
  lijar: true,
  limar: true,
  limbo: true,
  limón: true,
  linar: true,
  lince: true,
  lindo: true,
  línea: true,
  linfa: true,
  lioso: true,
  liria: true,
  lirio: true,
  lirón: true,
  lista: true,
  listo: true,
  litio: true,
  litro: true,
  llaga: true,
  llama: true,
  llana: true,
  llano: true,
  llave: true,
  llega: true,
  llena: true,
  lleno: true,
  lleva: true,
  lleve: true,
  lloro: true,
  local: true,
  logos: true,
  logro: true,
  lonja: true,
  lorza: true,
  lucha: true,
  luche: true,
  lucir: true,
  lucro: true,
  luego: true,
  lugar: true,
  lumen: true,
  lunar: true,
  lunes: true,
  luxar: true,
  lycra: true,
  macho: true,
  macro: true,
  madre: true,
  maese: true,
  mafia: true,
  magma: true,
  magno: true,
  magra: true,
  magro: true,
  mahón: true,
  majal: true,
  majar: true,
  malar: true,
  malla: true,
  malta: true,
  malva: true,
  mamar: true,
  mamba: true,
  mambo: true,
  mamón: true,
  mamut: true,
  manar: true,
  manco: true,
  mando: true,
  manga: true,
  mango: true,
  manía: true,
  manso: true,
  manta: true,
  manto: true,
  maorí: true,
  marca: true,
  marco: true,
  marea: true,
  mareo: true,
  marra: true,
  marte: true,
  marzo: true,
  masái: true,
  masía: true,
  masón: true,
  matar: true,
  matiz: true,
  matón: true,
  maula: true,
  mayor: true,
  meada: true,
  meado: true,
  mecer: true,
  mecha: true,
  media: true,
  medio: true,
  medir: true,
  medra: true,
  meigo: true,
  mejor: true,
  melar: true,
  mella: true,
  melón: true,
  memez: true,
  menor: true,
  menos: true,
  menta: true,
  mente: true,
  merma: true,
  mesar: true,
  mesón: true,
  metal: true,
  meter: true,
  metro: true,
  micra: true,
  miedo: true,
  migar: true,
  migra: true,
  milla: true,
  mimar: true,
  minar: true,
  minué: true,
  mioma: true,
  miope: true,
  mirar: true,
  mirlo: true,
  mirón: true,
  mirra: true,
  mismo: true,
  mitad: true,
  mitón: true,
  mitra: true,
  miura: true,
  mixta: true,
  mixto: true,
  mocho: true,
  modal: true,
  mohín: true,
  mojar: true,
  mojón: true,
  molar: true,
  molde: true,
  moler: true,
  molla: true,
  momia: true,
  monje: true,
  monta: true,
  monte: true,
  monto: true,
  moral: true,
  morar: true,
  morbo: true,
  morir: true,
  morro: true,
  morsa: true,
  morse: true,
  mosca: true,
  mosto: true,
  motel: true,
  motín: true,
  motor: true,
  móvil: true,
  mucho: true,
  mudar: true,
  mudez: true,
  mueca: true,
  muela: true,
  muelo: true,
  muera: true,
  mugir: true,
  mugre: true,
  mujer: true,
  mular: true,
  multa: true,
  mundo: true,
  muñón: true,
  mural: true,
  murga: true,
  museo: true,
  musgo: true,
  muslo: true,
  mutar: true,
  mutis: true,
  mutua: true,
  mutuo: true,
  nácar: true,
  nacer: true,
  nacho: true,
  nadar: true,
  nadie: true,
  nafta: true,
  naipe: true,
  nalga: true,
  narco: true,
  nardo: true,
  nariz: true,
  narra: true,
  nasal: true,
  natal: true,
  naval: true,
  navío: true,
  necio: true,
  negar: true,
  negra: true,
  negro: true,
  nerón: true,
  neura: true,
  nevar: true,
  nicho: true,
  niego: true,
  nieto: true,
  nieve: true,
  nimbo: true,
  nimio: true,
  ninfa: true,
  niñez: true,
  nipón: true,
  nitro: true,
  nivel: true,
  níveo: true,
  nobel: true,
  noble: true,
  noche: true,
  noema: true,
  nogal: true,
  nonio: true,
  noria: true,
  norma: true,
  notar: true,
  noval: true,
  novel: true,
  novio: true,
  nublo: true,
  nuera: true,
  nueva: true,
  nueve: true,
  nuevo: true,
  numen: true,
  nunca: true,
  nutra: true,
  oasis: true,
  obeso: true,
  óbice: true,
  óbito: true,
  oblea: true,
  óbolo: true,
  obrar: true,
  obvio: true,
  ocaso: true,
  odeón: true,
  odiar: true,
  oeste: true,
  ohmio: true,
  oídio: true,
  oidor: true,
  ojear: true,
  ojera: true,
  ojete: true,
  ojiva: true,
  okapi: true,
  olida: true,
  oliva: true,
  olivo: true,
  omaso: true,
  omega: true,
  omiso: true,
  ondeo: true,
  ónice: true,
  opaco: true,
  ópalo: true,
  ópera: true,
  optar: true,
  orden: true,
  oreja: true,
  orgía: true,
  orina: true,
  orine: true,
  orlar: true,
  ornar: true,
  oruga: true,
  orujo: true,
  orzar: true,
  osado: true,
  óscar: true,
  osera: true,
  osmio: true,
  ostra: true,
  otear: true,
  otero: true,
  otoño: true,
  óvalo: true,
  oveja: true,
  óvido: true,
  ovino: true,
  óvolo: true,
  óvulo: true,
  óxido: true,
  ozono: true,
  pacer: true,
  pacto: true,
  pádel: true,
  padre: true,
  pagar: true,
  pajar: true,
  palco: true,
  palia: true,
  palma: true,
  pampa: true,
  panal: true,
  panda: true,
  pando: true,
  panel: true,
  panza: true,
  pañal: true,
  papal: true,
  papel: true,
  papúa: true,
  parar: true,
  parca: true,
  parco: true,
  pardo: true,
  pared: true,
  pareo: true,
  paria: true,
  parir: true,
  parka: true,
  parla: true,
  parra: true,
  parte: true,
  parto: true,
  parvo: true,
  pasar: true,
  paseo: true,
  pasmo: true,
  pasta: true,
  paste: true,
  pasto: true,
  patán: true,
  patas: true,
  pateo: true,
  páter: true,
  patín: true,
  patio: true,
  pausa: true,
  pauta: true,
  pauto: true,
  pavor: true,
  pecar: true,
  pecho: true,
  pecio: true,
  pedal: true,
  pedir: true,
  pegar: true,
  pegue: true,
  peina: true,
  peine: true,
  pelar: true,
  pelea: true,
  pella: true,
  pelón: true,
  penal: true,
  penar: true,
  penca: true,
  peñón: true,
  peral: true,
  perca: true,
  perla: true,
  perno: true,
  perra: true,
  perro: true,
  persa: true,
  pesar: true,
  pesca: true,
  peste: true,
  pezón: true,
  piano: true,
  picar: true,
  picón: true,
  picor: true,
  pieza: true,
  pifia: true,
  pilar: true,
  pilla: true,
  pillo: true,
  pilón: true,
  pinar: true,
  pinta: true,
  pinto: true,
  pinza: true,
  piñón: true,
  piojo: true,
  pique: true,
  pisar: true,
  pista: true,
  pitar: true,
  pitio: true,
  pitón: true,
  pívot: true,
  pizca: true,
  pizco: true,
  pizza: true,
  placa: true,
  plaga: true,
  plana: true,
  plano: true,
  plata: true,
  plato: true,
  plató: true,
  plaza: true,
  plazo: true,
  plebe: true,
  plena: true,
  pleno: true,
  plexo: true,
  plomo: true,
  pluma: true,
  pobre: true,
  pocha: true,
  pocho: true,
  podar: true,
  poder: true,
  podio: true,
  podón: true,
  poema: true,
  poeta: true,
  póker: true,
  polar: true,
  polca: true,
  polea: true,
  polen: true,
  polio: true,
  polis: true,
  pollo: true,
  polvo: true,
  pómez: true,
  pompa: true,
  poner: true,
  pongo: true,
  porno: true,
  porra: true,
  porro: true,
  porta: true,
  porte: true,
  posar: true,
  posta: true,
  poste: true,
  potra: true,
  potro: true,
  prado: true,
  presa: true,
  preso: true,
  prima: true,
  primo: true,
  prior: true,
  prisa: true,
  probo: true,
  prole: true,
  prosa: true,
  púber: true,
  pubis: true,
  pudin: true,
  pudor: true,
  púgil: true,
  pugna: true,
  pujar: true,
  pulga: true,
  pulir: true,
  pulla: true,
  pulpa: true,
  pulpo: true,
  pulso: true,
  punir: true,
  punta: true,
  punto: true,
  puñal: true,
  purga: true,
  quark: true,
  queda: true,
  queja: true,
  quema: true,
  quemo: true,
  queso: true,
  quien: true,
  quién: true,
  quita: true,
  quite: true,
  quito: true,
  quizá: true,
  rabia: true,
  racha: true,
  radar: true,
  radio: true,
  radón: true,
  rafia: true,
  raído: true,
  rajar: true,
  rallo: true,
  ramal: true,
  ramos: true,
  rampa: true,
  rango: true,
  rapar: true,
  rapaz: true,
  rapel: true,
  rapto: true,
  rasar: true,
  rasgo: true,
  raspa: true,
  raspe: true,
  ratio: true,
  ratón: true,
  rauda: true,
  raudo: true,
  rayar: true,
  rayón: true,
  razón: true,
  recio: true,
  recta: true,
  recto: true,
  redil: true,
  regar: true,
  regio: true,
  regir: true,
  regla: true,
  rehén: true,
  reina: true,
  rejón: true,
  relax: true,
  reloj: true,
  remar: true,
  renal: true,
  renco: true,
  renga: true,
  rengo: true,
  renta: true,
  rento: true,
  reñir: true,
  reojo: true,
  resma: true,
  resta: true,
  resto: true,
  retal: true,
  retar: true,
  retro: true,
  reuma: true,
  rezar: true,
  riada: true,
  riego: true,
  rifle: true,
  rigor: true,
  rimar: true,
  rímel: true,
  rinde: true,
  riñón: true,
  rioja: true,
  risco: true,
  ritmo: true,
  rival: true,
  rizar: true,
  robar: true,
  roble: true,
  robot: true,
  rocín: true,
  rocío: true,
  rodal: true,
  rodar: true,
  rodea: true,
  rodeo: true,
  rodio: true,
  rogar: true,
  roído: true,
  rojez: true,
  rollo: true,
  rombo: true,
  ronca: true,
  ronce: true,
  ronco: true,
  ronda: true,
  rondó: true,
  roque: true,
  rosal: true,
  rosca: true,
  rosco: true,
  rotar: true,
  rotor: true,
  rozar: true,
  ruano: true,
  rubio: true,
  rubor: true,
  rucio: true,
  rueca: true,
  rueda: true,
  ruedo: true,
  ruego: true,
  rugir: true,
  ruido: true,
  ruina: true,
  rumba: true,
  rumbo: true,
  rumor: true,
  rupia: true,
  rural: true,
  saber: true,
  sabio: true,
  sable: true,
  sabor: true,
  sacar: true,
  sacio: true,
  sacra: true,
  sacro: true,
  saeta: true,
  sagaz: true,
  sajar: true,
  sajón: true,
  salar: true,
  salaz: true,
  saldo: true,
  salio: true,
  salir: true,
  salmo: true,
  salón: true,
  salsa: true,
  salto: true,
  salud: true,
  salva: true,
  salve: true,
  salvo: true,
  samba: true,
  sanar: true,
  santa: true,
  santo: true,
  saque: true,
  sarda: true,
  sardo: true,
  sargo: true,
  sarna: true,
  sarro: true,
  sarta: true,
  satán: true,
  satén: true,
  sauce: true,
  saudí: true,
  sauna: true,
  savia: true,
  sazón: true,
  secar: true,
  secta: true,
  sedal: true,
  sedán: true,
  sedar: true,
  segar: true,
  según: true,
  sello: true,
  selva: true,
  semen: true,
  senda: true,
  senil: true,
  señal: true,
  señor: true,
  sepia: true,
  septo: true,
  serie: true,
  serio: true,
  servo: true,
  seseo: true,
  sesga: true,
  sesgo: true,
  sexta: true,
  sexto: true,
  shock: true,
  sidra: true,
  siega: true,
  siena: true,
  siete: true,
  sifón: true,
  sigla: true,
  siglo: true,
  sigma: true,
  signo: true,
  silba: true,
  silbo: true,
  sílex: true,
  silla: true,
  silva: true,
  símil: true,
  simio: true,
  sirio: true,
  siseo: true,
  sismo: true,
  sitio: true,
  sobar: true,
  sobra: true,
  sobre: true,
  socio: true,
  sodio: true,
  solar: true,
  solaz: true,
  sóleo: true,
  soler: true,
  solfa: true,
  solio: true,
  sonar: true,
  sonda: true,
  soñar: true,
  soplo: true,
  sopor: true,
  sorbo: true,
  sorda: true,
  sordo: true,
  sorna: true,
  suave: true,
  subir: true,
  sucio: true,
  sudar: true,
  sudor: true,
  sueco: true,
  suela: true,
  suelo: true,
  sueño: true,
  suero: true,
  suevo: true,
  suflé: true,
  sufra: true,
  suite: true,
  suiza: true,
  suizo: true,
  sumar: true,
  sumir: true,
  surco: true,
  susto: true,
  sutil: true,
  swing: true,
  tabla: true,
  tacha: true,
  tache: true,
  tacón: true,
  tacto: true,
  tahúr: true,
  talar: true,
  talco: true,
  talio: true,
  talla: true,
  talle: true,
  tallo: true,
  talón: true,
  talud: true,
  tamiz: true,
  tanda: true,
  tanga: true,
  tango: true,
  tanto: true,
  tañer: true,
  tapar: true,
  tapir: true,
  tarar: true,
  tarde: true,
  tardo: true,
  tarea: true,
  tarot: true,
  tarro: true,
  tarso: true,
  tarta: true,
  tasar: true,
  tasca: true,
  tauro: true,
  tazón: true,
  tebeo: true,
  techo: true,
  tecla: true,
  tedio: true,
  teína: true,
  tejar: true,
  tejer: true,
  tejón: true,
  telar: true,
  telón: true,
  temer: true,
  temor: true,
  tempo: true,
  tenaz: true,
  tener: true,
  tenis: true,
  tenor: true,
  tenso: true,
  tenue: true,
  teñir: true,
  terco: true,
  terma: true,
  termo: true,
  terna: true,
  terno: true,
  terso: true,
  tesis: true,
  tesla: true,
  tesón: true,
  testa: true,
  texto: true,
  tiara: true,
  tibia: true,
  tibio: true,
  tieso: true,
  tifón: true,
  tifus: true,
  tigre: true,
  tilde: true,
  timar: true,
  timba: true,
  timón: true,
  tinta: true,
  tinte: true,
  tinto: true,
  tiple: true,
  tique: true,
  tirar: true,
  tirón: true,
  tisis: true,
  titán: true,
  tizna: true,
  tizne: true,
  tizón: true,
  tocar: true,
  tocón: true,
  toldo: true,
  tolva: true,
  tomar: true,
  tonal: true,
  tonel: true,
  tongo: true,
  tonto: true,
  topar: true,
  toque: true,
  tórax: true,
  tordo: true,
  toreo: true,
  toril: true,
  torio: true,
  tormo: true,
  torna: true,
  torno: true,
  torpe: true,
  torre: true,
  torso: true,
  torta: true,
  torva: true,
  torvo: true,
  tosca: true,
  tosco: true,
  toser: true,
  total: true,
  tótem: true,
  traba: true,
  traca: true,
  trace: true,
  traer: true,
  trago: true,
  traje: true,
  trama: true,
  tramo: true,
  trapo: true,
  trata: true,
  trato: true,
  traza: true,
  trazo: true,
  trece: true,
  treta: true,
  tribu: true,
  trigo: true,
  trino: true,
  tripa: true,
  tripe: true,
  triza: true,
  troco: true,
  trole: true,
  trona: true,
  trono: true,
  tropa: true,
  trote: true,
  trova: true,
  trovo: true,
  trozo: true,
  truco: true,
  trufa: true,
  tucán: true,
  tueco: true,
  tulio: true,
  tumba: true,
  tumbo: true,
  tumor: true,
  tunda: true,
  túnel: true,
  tupir: true,
  turba: true,
  turbo: true,
  turca: true,
  turco: true,
  turno: true,
  tuteo: true,
  tutor: true,
  twist: true,
  ufano: true,
  ujier: true,
  ultra: true,
  umbra: true,
  umbro: true,
  uncir: true,
  ungir: true,
  único: true,
  unión: true,
  untar: true,
  uñate: true,
  uñero: true,
  urdir: true,
  urgir: true,
  úrico: true,
  usado: true,
  usted: true,
  usual: true,
  usura: true,
  útero: true,
  vacar: true,
  vacío: true,
  vacuo: true,
  vadeo: true,
  vagar: true,
  vagón: true,
  vaina: true,
  valer: true,
  valía: true,
  valla: true,
  valle: true,
  valón: true,
  valor: true,
  vapor: true,
  varar: true,
  vario: true,
  variz: true,
  varón: true,
  vasar: true,
  vasco: true,
  vasto: true,
  váter: true,
  vatio: true,
  vedar: true,
  vejar: true,
  vejez: true,
  velar: true,
  vello: true,
  velón: true,
  veloz: true,
  venda: true,
  venia: true,
  venir: true,
  venta: true,
  venus: true,
  veras: true,
  veraz: true,
  verbo: true,
  verde: true,
  verja: true,
  vermú: true,
  verso: true,
  vetar: true,
  viaje: true,
  vicia: true,
  vicio: true,
  vieja: true,
  viejo: true,
  vigía: true,
  vigor: true,
  villa: true,
  viola: true,
  viral: true,
  virar: true,
  virgo: true,
  viril: true,
  virus: true,
  visar: true,
  visir: true,
  visor: true,
  vista: true,
  visto: true,
  vital: true,
  vítor: true,
  viuda: true,
  viudo: true,
  vivaz: true,
  vivir: true,
  vocal: true,
  voceo: true,
  vodka: true,
  volar: true,
  volea: true,
  voraz: true,
  voseo: true,
  votar: true,
  vuelo: true,
  vulgo: true,
  vulva: true,
  weber: true,
  xenón: true,
  yacer: true,
  yanta: true,
  yarda: true,
  yegua: true,
  yelmo: true,
  yerba: true,
  yermo: true,
  yerno: true,
  yesca: true,
  yogui: true,
  yogur: true,
  yunta: true,
  zafar: true,
  zafio: true,
  zagal: true,
  zaino: true,
  zanca: true,
  zanco: true,
  zanja: true,
  zapar: true,
  zarco: true,
  zarpa: true,
  zarza: true,
  zarzo: true,
  zombi: true,
  zonal: true,
  zorra: true,
  zorro: true,
  zueco: true,
  zumbo: true,
  zurda: true,
  zurdo: true,
  zurra: true,
  ñandú: true,
  ñoñez: true,
  ñoqui: true,
}

export default words
